export default __webpack_public_path__ + "static/media/addorder.f2931490.svg";